import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",

  contrNo: null,
  siteNo: null,
  SEQ: null,
  subjectNo: null,
  rptTerm: null,
  onsetDate: null,
  ongoing: null,
  endDate: null,
  IRBRpt: null,
  cmt: null,
  IRBRptCmt: null,

  fuRptDate: {},
  IRBRptDate: [],
};

export const SAESlice = createSlice({
  name: "SAE",
  initialState,
  reducers: {
    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    updateSiteNo: (state, action) => {
      return {
        ...state,
        siteNo: action.payload.siteNo,
      };
    },

    updateSubjectNo: (state, action) => {
      return {
        ...state,
        subjectNo: action.payload.subjectNo,
      };
    },

    updateRptTerm: (state, action) => {
      return {
        ...state,
        rptTerm: action.payload.rptTerm,
      };
    },

    updateOnsetDate: (state, action) => {
      return {
        ...state,
        onsetDate: action.payload.onsetDate,
      };
    },

    updateOngoing: (state, action) => {
      return {
        ...state,
        ongoing: action.payload.ongoing,
      };
    },

    updateEndDate: (state, action) => {
      return {
        ...state,
        endDate: action.payload.endDate,
      };
    },

    updateFuRptDate: (state, action) => {
      return {
        ...state,
        fuRptDate: {
          ...state.fuRptDate,
          ...action.payload,
        },
      };
    },

    updateCmt: (state, action) => {
      return {
        ...state,
        cmt: action.payload.cmt,
      };
    },

    updateIRBRpt: (state, action) => {
      return {
        ...state,
        IRBRpt: action.payload.IRBRpt,
      };
    },

    updateIRBRptDate: (state, action) => {
      return {
        ...state,
        IRBRptDate: {
          ...state.IRBRptDate,
          ...action.payload,
        },
      };
    },

    updateIRBRptCmt: (state, action) => {
      return {
        ...state,
        IRBRptCmt: action.payload.IRBRptCmt,
      };
    },

    init: (state, action) => {
      return {
        ...initialState,
      };
    },

    updateAll: (state, action) => {
      return {
        ...action.payload,
      };
    },
  },
});

export const {
  updateAction,
  updateSiteNo,
  updateSubjectNo,
  updateRptTerm,
  updateOnsetDate,
  updateOngoing,
  updateEndDate,
  updateFuRptDate,
  updateCmt,
  updateIRBRpt,
  updateIRBRptDate,
  updateIRBRptCmt,
  init,
  updateAll,
} = SAESlice.actions;

export default SAESlice.reducer;
